var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftRightTreeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b73bbbba6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.839844 276.828125 L 345.175781 276.828125 L 345.175781 533.167969 L 88.839844 533.167969 Z M 88.839844 276.828125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d80d139fed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.839844 404.996094 C 88.839844 475.785156 146.222656 533.167969 217.007812 533.167969 C 287.792969 533.167969 345.175781 475.785156 345.175781 404.996094 C 345.175781 334.210938 287.792969 276.828125 217.007812 276.828125 C 146.222656 276.828125 88.839844 334.210938 88.839844 404.996094 Z M 88.839844 404.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb37e7f38f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.839844 276.832031 L 345.175781 276.832031 L 345.175781 533.167969 L 88.839844 533.167969 Z M 88.839844 276.832031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c0cdcb4eb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.839844 405 C 88.839844 475.785156 146.222656 533.167969 217.007812 533.167969 C 287.792969 533.167969 345.175781 475.785156 345.175781 405 C 345.175781 334.214844 287.792969 276.832031 217.007812 276.832031 C 146.222656 276.832031 88.839844 334.214844 88.839844 405 Z M 88.839844 405 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc4a44bcdf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 36.839844 L 721.160156 36.839844 L 721.160156 201.273438 L 556.726562 201.273438 Z M 556.726562 36.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aef4b74cab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 119.058594 C 556.726562 164.464844 593.535156 201.273438 638.945312 201.273438 C 684.351562 201.273438 721.160156 164.464844 721.160156 119.058594 C 721.160156 73.648438 684.351562 36.839844 638.945312 36.839844 C 593.535156 36.839844 556.726562 73.648438 556.726562 119.058594 Z M 556.726562 119.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b365e12613"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 37.023438 L 720.976562 37.023438 L 720.976562 201.273438 L 556.726562 201.273438 Z M 556.726562 37.023438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "999c94cf6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 119.0625 C 556.726562 164.464844 593.535156 201.273438 638.941406 201.273438 C 684.34375 201.273438 721.152344 164.464844 721.152344 119.0625 C 721.152344 73.65625 684.34375 36.847656 638.941406 36.847656 C 593.535156 36.847656 556.726562 73.65625 556.726562 119.0625 Z M 556.726562 119.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5267ca8c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 608.707031 L 721.160156 608.707031 L 721.160156 773.144531 L 556.726562 773.144531 Z M 556.726562 608.707031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4c6bad5f41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 690.925781 C 556.726562 736.332031 593.535156 773.144531 638.945312 773.144531 C 684.351562 773.144531 721.160156 736.332031 721.160156 690.925781 C 721.160156 645.519531 684.351562 608.707031 638.945312 608.707031 C 593.535156 608.707031 556.726562 645.519531 556.726562 690.925781 Z M 556.726562 690.925781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6371e70b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 608.894531 L 720.976562 608.894531 L 720.976562 773.144531 L 556.726562 773.144531 Z M 556.726562 608.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "00bfe93c8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 690.929688 C 556.726562 736.335938 593.535156 773.144531 638.941406 773.144531 C 684.34375 773.144531 721.152344 736.335938 721.152344 690.929688 C 721.152344 645.523438 684.34375 608.71875 638.941406 608.71875 C 593.535156 608.71875 556.726562 645.523438 556.726562 690.929688 Z M 556.726562 690.929688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c63c03950"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 322.773438 L 721.160156 322.773438 L 721.160156 487.207031 L 556.726562 487.207031 Z M 556.726562 322.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4d8df73b8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 404.992188 C 556.726562 450.398438 593.535156 487.207031 638.945312 487.207031 C 684.351562 487.207031 721.160156 450.398438 721.160156 404.992188 C 721.160156 359.585938 684.351562 322.773438 638.945312 322.773438 C 593.535156 322.773438 556.726562 359.585938 556.726562 404.992188 Z M 556.726562 404.992188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75822d3e99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 322.957031 L 720.976562 322.957031 L 720.976562 487.207031 L 556.726562 487.207031 Z M 556.726562 322.957031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e86d5a7b0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 556.726562 404.996094 C 556.726562 450.402344 593.535156 487.207031 638.941406 487.207031 C 684.34375 487.207031 721.152344 450.402344 721.152344 404.996094 C 721.152344 359.589844 684.34375 322.78125 638.941406 322.78125 C 593.535156 322.78125 556.726562 359.589844 556.726562 404.996094 Z M 556.726562 404.996094 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b73bbbba6c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d80d139fed)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M 88.839844 533.167969 L 88.839844 276.828125 L 345.175781 276.828125 L 345.175781 533.167969 Z M 88.839844 533.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb37e7f38f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0cdcb4eb3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 88.839073, 533.166785)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 170.889055 0.00102709 C 76.508842 0.00102709 -0.0015781 76.511448 -0.0015781 170.891661 C -0.0015781 265.271874 76.508842 341.782294 170.889055 341.782294 C 265.269269 341.782294 341.779689 265.271874 341.779689 170.891661 C 341.779689 76.511448 265.269269 0.00102709 170.889055 0.00102709 Z M 170.889055 0.00102709 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc4a44bcdf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aef4b74cab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54ff71",
    d: "M 556.726562 201.273438 L 556.726562 36.839844 L 721.160156 36.839844 L 721.160156 201.273438 Z M 556.726562 201.273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b365e12613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#999c94cf6d)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 556.726727, 201.274594)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.616131 -0.000219989 C 49.079669 -0.000219989 0.00154183 49.077907 0.00154183 109.619577 C 0.00154183 170.156039 49.079669 219.234166 109.616131 219.234166 C 170.1578 219.234166 219.235928 170.156039 219.235928 109.619577 C 219.235928 49.077907 170.1578 -0.000219989 109.616131 -0.000219989 Z M 109.616131 -0.000219989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a5267ca8c6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4c6bad5f41)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33adff",
    d: "M 556.726562 773.144531 L 556.726562 608.707031 L 721.160156 608.707031 L 721.160156 773.144531 Z M 556.726562 773.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6371e70b3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00bfe93c8e)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 556.726727, 773.142869)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.617581 -0.000219989 C 49.075911 -0.000219989 -0.00221619 49.077907 -0.00221619 109.619577 C -0.00221619 170.156039 49.075911 219.234166 109.617581 219.234166 C 170.159251 219.234166 219.23217 170.156039 219.23217 109.619577 C 219.23217 49.077907 170.159251 -0.000219989 109.617581 -0.000219989 Z M 109.617581 -0.000219989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c63c03950)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4d8df73b8b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff78e6",
    d: "M 556.726562 487.207031 L 556.726562 322.773438 L 721.160156 322.773438 L 721.160156 487.207031 Z M 556.726562 487.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75822d3e99)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e86d5a7b0c)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, -0.75, 0.75, 0, 556.726727, 487.208731)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 109.616856 -0.000219989 C 49.075186 -0.000219989 0.00226699 49.077907 0.00226699 109.619577 C 0.00226699 170.156039 49.075186 219.234166 109.616856 219.234166 C 170.158526 219.234166 219.236653 170.156039 219.236653 109.619577 C 219.236653 49.077907 170.158526 -0.000219989 109.616856 -0.000219989 Z M 109.616856 -0.000219989 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000001309, -0.75, 0.75, 0.000000001309, 446.423093, 693.930033)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.000460796 5.998376 L 385.245272 5.998376 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.75, -0.75, 0, 455.424053, 115.918572)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000804024 5.997695 L 385.447132 5.997695 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.75, 0, 0, -0.75, 556.724279, 409.499999)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00216432 5.999999 L 282.064679 5.999999 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0.000000000000000604, -0.000000000000000604, 0.75, 450.927365, 686.434089)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00211142 5.999339 L 141.065604 5.999339 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 448.564013, 114.565877)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00201724 6.000706 L 144.21674 6.000706 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRightTreeLight);
export default __webpack_public_path__ + "static/media/left_right_tree_light.3d64b77d9bc3d1b1af74d9e71b2df901.svg";
export { ForwardRef as ReactComponent };